import { lazy, Suspense, type ReactNode } from 'react'
import { IS_PRIVY_AUTH } from './auth-config'

const PrivyRoot = lazy(() => import('./privy-root'))

interface Props {
  children: ReactNode
}

/**
 * Mounts the Privy SDK when `VITE_AUTH_PROVIDER=privy`; otherwise renders the
 * children as they are, so the legacy wallet-challenge flow is untouched.
 */
export const AuthProvider = ({ children }: Props) => {
  if (!IS_PRIVY_AUTH) return <>{children}</>

  return (
    <Suspense fallback={null}>
      <PrivyRoot>{children}</PrivyRoot>
    </Suspense>
  )
}
